import React, { useEffect, useState } from 'react';
import AssetProps from '../interfaces/AssetProps';
import './AssetDetails.css';
import AssetDetailsPanel from './AssetDetailsPanel';
import AssetNetworkTest from './AssetNetworkTest';
import AssetParameters from './AssetParameters';
import Spinner from './Spinner';
import { Steps, Switch } from 'antd';
import { legendRfData } from '../services/helper';
import { CaretDownOutlined } from '@ant-design/icons';

interface AssetDetailsProps {
  goBack: any;
  asset: AssetProps | undefined;
  setAction: any;
  rmaSerialNumber: any;
  setUpdatedAsset: any;
  refreshAsset: any;
  getRFAnalysis: (latlng: string) => void;
  getBuildingPolygons: (lat: number, lng: number) => void;
  viewRFPathAnalysis: boolean;
  setViewRFPathAnalysis: (value: boolean) => void;
  showActionPanel: boolean;
  setShowActionPanel: (value: boolean) => void;
}

const AssetDetails: React.FC<AssetDetailsProps> = ({
  rmaSerialNumber,
  goBack,
  asset,
  setAction,
  setUpdatedAsset,
  refreshAsset,
  getRFAnalysis,
  getBuildingPolygons,
  viewRFPathAnalysis,
  setViewRFPathAnalysis,
  setShowActionPanel,
  showActionPanel,
}) => {
  const [activeTab, setActiveTab] = useState('parameter');
  const [loading, setLoading] = useState(false);

  const getProgress = () => {
    // "reg_pending": fields.Boolean,
    // "usm_creation": fields.Boolean,
    // "grant_aquired": fields.Boolean,
    // "registered": fields.Boolean,
    // "authorized": fields.Boolean,
    // "on_air": fields.Boolean,

    if (asset?.asset?.state_machine?.reg_pending) {
      return 0;
    }
    if (asset?.asset?.state_machine?.usm_creation) {
      return 1;
    }
    if (asset?.asset?.state_machine?.grant_aquired) {
      return 2;
    }
    if (asset?.asset?.state_machine?.registered) {
      return 3;
    }
    if (asset?.asset?.state_machine?.authorized) {
      return 4;
    }
    if (asset?.asset?.state_machine?.on_air) {
      return 5;
    }
    return -1;
  };

  return (
    <div className="h-100 overflow-auto row-wise justify-content-between">
      {/* Card for the left side details */}
      {showActionPanel && (
        <AssetDetailsPanel
          getRFAnalysis={getRFAnalysis}
          rmaSerialNumber={rmaSerialNumber}
          assetDetails={asset}
          goBack={goBack}
          setAction={setAction}
          getBuildingPolygons={getBuildingPolygons}
        />
      )}
      {/* <div className="bg-card">
        <Steps
          className="steps-status"
          size="small"
          progressDot
          current={getProgress() != -1 ? getProgress() : 3}
          type="inline"
          items={[
            {
              title: 'SAS Registration Pending',
            },
            {
              title: 'NE Created in USM',
            },
            {
              title: 'Grant Acquired',
            },
            {
              title: 'Registered',
            },
            {
              title: 'Authorized',
            },
            {
              title: 'On Air',
            },
          ]}
        />
      </div> */}
      {/* card for the right side details */}
      {showActionPanel && (
        <div className="plain-card position-relative  bg-card ">
          <div className="row-wise mt-2 bg-card ">
            <div
              // className={activeTab === 'parameter' ? 'active-tab' : 'inactive-tab'}
              className="app-card-action-heading fw-bold px-4 pb-1 pt-2"
              onClick={() => {
                setActiveTab('parameter');
              }}>
              Parameters
            </div>
            {/* <div
            className={activeTab === 'network-test' ? 'active-tab' : 'inactive-tab'}
            onClick={() => {
              setActiveTab('network-test');
            }}>
            Network Test
          </div> */}
          </div>
          {activeTab === 'parameter' ? (
            <AssetParameters
              processing={(value: boolean) => {
                setLoading(value);
              }}
              setUpdatedAsset={setUpdatedAsset}
              refreshAsset={refreshAsset}
              assetDetails={asset}
            />
          ) : (
            <AssetNetworkTest />
          )}
        </div>
      )}

      <div className="position-fixed bottom-0 start-50 translate-middle-x rounded-top">
        <div className="rf-legend-bottom p-2 rounded-2">
          {/* Legend Bar */}
          <div className="pb-2">
            <label style={{ fontSize: '12px' }}>Asset action panel</label>
            <Switch
              className="ms-2"
              size="small"
              checkedChildren="Show"
              unCheckedChildren="Hide"
              checked={showActionPanel}
              onChange={(checked) => setShowActionPanel(checked)}
            />
          </div>
          <div
            style={{
              display: 'flex',
              height: 40,
              overflow: 'hidden',
              // border: '1px solid #ccc',
            }}>
            {legendRfData.map((item, index) => (
              <div key={index} style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
                <div
                  key={index}
                  style={{
                    flex: 1,
                    backgroundColor: `rgb(${item.r}, ${item.g}, ${item.b})`,
                    width: '100%',
                  }}
                  title={item.l}
                />
                <label className="rf-legenf-label">{item.l.split('d')[0]}</label>
              </div>
            ))}
          </div>

          {/* Labels */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 6,
              fontSize: 12,
              color: '#444',
            }}>
            <span className="rf-legend-title">High (-20 dBm)</span>
            <label className="fw-bold">Expected Signal Strength</label>

            <span className="rf-legend-title">Low (-112 dBm)</span>
          </div>
        </div>
      </div>

      <Spinner show={loading} />
    </div>
  );
};

export default AssetDetails;
